import API from "../API/newIndex";

export const uploadTextEditorImage = async (file) => {
  console.log(file, 'file');
  const result = await API({
    url: "/admin/fileupload/upload",
    method: "POST",
    data: file,
  });
console.log(result, 'result');
  if (result?.data?.data?.length > 0) {
    return result.data.data[0];
  }

  throw new Error("Image upload failed");
};
